var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"video-box"},[_c('div',{ref:"dplayer",staticClass:"dplayer",attrs:{"id":"dplayer"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }